/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useState } from 'react'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { isMobile } from 'react-device-detect'
import * as _ from 'lodash'
import { useOnMount } from '@utils/reactExt'
import { ListView } from 'antd-mobile'
// css
import BottomLoading from '@components/BottomLoading'
import TIP_NUMBER_IMAGES from '@assets/images/guide/tip-number'
import { Button } from '@styles/button.style'
import { TipListWrap } from '../index.style'

const TipList: React.FC = () => {
  const { globalStore, componentStore } = useRootStore()
  const [isLoading, setIsLoading] = useState(false)
  const [hasMore, setHasMore] = useState(false)
  const [tips, setTips] = useState(null)

  const tipNumberImagesSize = _.size(TIP_NUMBER_IMAGES)

  const [dataSource, setDataSource] = useState(new ListView.DataSource({
    rowHasChanged: (row1, row2) => row1 !== row2,
  }))

  const renderRow = (row, sectionId, rowId) => {
    let tipNumberImgSrc
    if (rowId < tipNumberImagesSize) {
      tipNumberImgSrc = <img src={TIP_NUMBER_IMAGES[rowId]} alt={`팁 ${rowId + 1}`}/>
    } else {
      tipNumberImgSrc = <img src={TIP_NUMBER_IMAGES[0]} alt={`팁 ${rowId + 1}`}/>
    }
    return (
      <Button
        className="tip-item"
        onClick={() => {
          onClickListItem(row)
        }}>
        <div>
          {tipNumberImgSrc}
        </div>
        <div>
          <img src={row?.thumbnailUrl} alt={row?.title}/>
        </div>
      </Button>
    )
  }

  const renderFooter = () => {
    let footer = <Fragment/>
    if (isLoading) {
      footer = <BottomLoading/>
    }
    return <div css={{ textAlign: 'center' }}>{footer}</div>
  }

  const onClickListItem = (row) => {
    componentStore.setTipDetail(row)
    globalStore.setVisibleTipDetail(true)
  }


  const fetch = async (reset?: boolean) => {
    try {
      setIsLoading(true)

      const params = {
        offset: reset ? 0 : _.size(tips),
      }
      const result = await componentStore.api.component.getPostedTips(params)

      let newTips = result.rows
      if (!reset) {
        newTips = _.concat(tips, newTips)
      }

      setTips(newTips)
      setDataSource(dataSource.cloneWithRows(newTips))
      setHasMore(result.hasMore)
    } catch (err) {
      console.error(err)
    } finally {
      setIsLoading(false)
    }
  }

  const endReachedHandler = async () => {
    if (isLoading) {
      return
    }
    if (hasMore) {
      await fetch()
    }
  }

  useOnMount(async () => {
    await fetch(true)
  })

  return (
    <TipListWrap className={!isMobile && 'pc-tip-list-wrap'}>
      <ListView
        renderRow={renderRow}
        dataSource={dataSource}
        renderFooter={renderFooter}
        onEndReached={endReachedHandler}
        scrollRenderAheadDistance={500}
        onEndReachedThreshold={10}
        initialListSize={20}
        pageSize={20}
        useBodyScroll={isMobile}
      />
    </TipListWrap>
  )
}

export default observer(TipList)
